import React from "react";
import { FinancialDocument } from "@common/types/financialDocument";
import { AccrualCounterpartyDetailChanges } from "./AccrualCounterpartyDetailChanges";
import { AccrualCounterpartyFilePreview } from "./AccrualCounterpartyFilePreview";
import { AccrualDraftCopy } from "./accrualDraftCopy";
import { AccrualCounterpartyDetailChangesState } from "./useAccrualCounterpartyDetailChanges";

interface Props {
    financialDocument: Pick<FinancialDocument, "id" | "fileName">;
    detailChanges: AccrualCounterpartyDetailChangesState;
    copy: AccrualDraftCopy;
    isHighlighted: boolean;
    appearance?: "panel" | "cell";
    isDisabled?: boolean;
    onCreateNew: () => void;
}

export const AccrualDraftCounterpartyDetailChanges: React.FC<Props> = ({
    financialDocument,
    detailChanges,
    copy,
    isHighlighted,
    appearance = "panel",
    isDisabled = false,
    onCreateNew,
}) => (
    <AccrualCounterpartyDetailChanges
        key={detailChanges.counterparty?.id}
        changes={detailChanges.changes}
        counterparty={detailChanges.counterparty}
        mergeSeeds={detailChanges.mergeSeeds}
        replacePreview={detailChanges.replacePreview}
        sidePreview={
            <AccrualCounterpartyFilePreview
                financialDocument={financialDocument}
            />
        }
        isHighlighted={isHighlighted}
        loadError={
            detailChanges.isDetailsError ? copy.changedDetailsLoadError : null
        }
        onRetry={detailChanges.retryDetails}
        reviewLabel={copy.changedDetailsTask}
        newCounterpartyAction={copy.newCounterpartyAction}
        appearance={appearance}
        isDisabled={isDisabled}
        onMerged={detailChanges.finishMerge}
        onCreateNew={onCreateNew}
        onSkip={detailChanges.skip}
    />
);
